import {GetBrowseBannerResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/browse_page/v1/service.types';
import {HeightTransition} from '@aboutyou/transitions';
import React, {FC, useEffect} from 'react';
import {CouponBanner} from '../../../features/Coupons/CouponBanner/CouponBanner';
import {SimpleWebCouponWrapper} from '../../../features/WebCouponBanner/SimpleWebCouponBanner';
import {useIsGenericWebCouponBannerEnabled} from '../../../features/WebCouponBanner/utils/useIsGenericWebCouponBannerEnabled';

export const BrowseBannerView = (
  props: GetBrowseBannerResponse & {
    className?: string;
  },
) => {
  const isAppWelcomeCouponBannerEnabled = useIsGenericWebCouponBannerEnabled();

  if (props.banner?.$case === 'discountCardsSlot') {
    return null;
  }

  if (props.banner?.$case === 'genericCouponBanner') {
    if (isAppWelcomeCouponBannerEnabled) {
      return (
        <SimpleWebCouponBannerWithTransition className={props.className} />
      );
    }

    return (
      <CouponBanner
        className={props.className}
        banner={props.banner.genericCouponBanner}
        data-testid="couponWalletBanner"
      />
    );
  }

  if (isAppWelcomeCouponBannerEnabled) {
    return <SimpleWebCouponBannerWithTransition className={props.className} />;
  }

  return null;
};

let appInstallBannerWasAnimated = false;

const SimpleWebCouponBannerWithTransition: FC<{
  className?: string;
}> = ({className}) => {
  useEffect(() => {
    appInstallBannerWasAnimated = true;
  }, []);

  return (
    <HeightTransition
      className={className}
      mounted
      duration={200}
      preventAnimationOnMount={appInstallBannerWasAnimated}
    >
      <SimpleWebCouponWrapper />
    </HeightTransition>
  );
};
